export enum SharingTipAction {
    ignore,
    refreshExpiration,
    changePermission,
    attachAsCopy, // TODO: Add attach a copy as sharing tip action for links in the body
}
